import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductCartPage = lazy(() => import('../views/list/ProductCartPage'));

export function ProductCartPageLazy() {
	return (
		<PageSuspense>
			<ProductCartPage />
		</PageSuspense>
	);
}
